
export default {
  parseSiteEdgePlaybackData: function (data) {
    return {
      completed: data.completed, // 0: not start,ing 1: success 2: failed
      created: data.created,
      deviceId: data.device_id,
      eventId: data.event_id,
      url: data.url,
      timestamp: data.timestamp,
      recordId: data.record_id,
      partitionNumber: data.partition_number != null ? String(data.partition_number) : null,
    }
  },
  parseDeviceEdgePlaybackData: function (data) {
    return {
      completed: data.completed,
      created: data.created,
      deviceId: data.device_id,
      eventId: data.event_id,
      url: data.url,
      timestamp: data.timestamp,
      recordId: data.record_id,
    }
  }
}